var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_1_",
    transform: "translate(.183 -.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M348.181 179.7l-1.681 1.681 5.523 5.523-5.523 5.523 1.681 1.681 7.2-7.2z",
    "data-name": "Path 14",
    transform: "translate(-336.174 -172.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26",
    fill: "none",
    d: "M0 0H29V29H0z",
    "data-name": "Rectangle 26",
    transform: "translate(-.183 .198)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-right.2c4ab387.svg";
export { ForwardRef as ReactComponent };